export default {
  setSalonsOverview(state, payload) {
    state.salonsOverview = payload;
  },
  setSalonDetailedReport(state, payload) {
    state.salonDetailedReport = {...payload};
  },
  setSalariesReport(state, payload) {
    state.salariesReport = payload;
  },
  setDiscountSummary(state, payload) {
    state.discountSummary = payload;
  },
  setSalonDailyReports(state, payload) {
    state.salonDailyReports = payload;
  },
  setTodayPaymentsReport(state, payload) {
    state.todayPaymentsReport = payload;
  }
}
